import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { ArrowLeftIcon, MapPinOff } from "lucide-react"
import { useNavigate } from "react-router-dom";

export function Restricted() {
  const navigate = useNavigate()
  return (
    <Card className="min-w-[381px] shadow-sm border-opacity-50 backdrop-blur-sm">
      <CardHeader className="pb-4">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <CardTitle className="text-2xl font-bold text-foreground">
              Restricted Access
            </CardTitle>
          </div>
          <MapPinOff className="h-8 w-8 text-muted-foreground" />
        </div>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <div className="text-destructive">Bench not available.</div>
        <div className="text-muted-foreground">
          This bench has been restricted for your region.
        </div>
        <Button
          variant="secondary"
          className="self-center mt-3"
          onClick={() => navigate("/bench")}
        >
          <ArrowLeftIcon />
          Go back
        </Button>
      </CardContent>
    </Card>
  );
}
